import { FC } from "react";
import profile from "../assets/avataaars.svg";

export const AboutGrete: FC = () => {
  return (
    <>
      <div className="text-primary-content bg-gradient-to-b from-secondary from-10% via-accent via-30% bg-pink-300 to-60% to-transparent">
        <div className="container relative flex flex-col justify-between h-full max-w-6xl px-10 mx-auto xl:px-0 pb-12">
          <h1 className="text-4xl font-semibold pt-12 pb-6 sm:text-5xl md:text-6xl">
            About me
          </h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-24">
            <div>
              <p className="pb-3">
                My passion has always been to deliver solutions that create real
                value for people.
              </p>
              <p className="py-3">
                As a project manager, I’m driven by curiosity and a genuine
                eagerness to learn and grow. I balance my professional ambitions
                with my roles as a mother of two, a wife, and a dog owner.
              </p>
              <p className="py-3">
                I thrive on turning innovative ideas into reality and seek out
                new knowledge at every opportunity.
              </p>
              <h1 className="text-3xl text-left font-semibold py-3 sm:text-4xl sm:py-4 md:text-5xl">
                Design-driven, growth-minded project manager
              </h1>
              <p className="py-3">
                I am passionate about innovation, UI/UX, and photography, and I
                approach every challenge as a chance to learn.
              </p>
              <p className="pt-3 pb-12">
                During my master’s studies at TalTech in Design and Technology,
                I led three projects, participated in hackathons and Baltic
                senior programs, and founded my own company, HPack. While that
                venture did not succeed, it reinforced my commitment to
                resilience, learning, and continuous improvement.
              </p>
            </div>
            <div>
              <div className="w-full h-full relative my-10">
                <img
                  className="w-full object-contain mask mask-squircle"
                  src={profile}
                  alt="greteprofile"
                  h-auto
                  w-auto
                  justify-content
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container relative flex flex-col justify-between h-full max-w-6xl px-10 mx-auto xl:px-0">
          <div className="w-full">
            <div className="flex flex-col w-full mt-6 mb-10 sm:flex-row">
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        Design Tools
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      Proficient in creating visually compelling interfaces
                      using Adobe XD and Figma.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        Research Methods
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      Skilled in Design Thinking, user interviews, surveys, and
                      journey mapping to drive user-centered results.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        Service Design Techniques
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      Experienced in service blueprinting, prototyping, and
                      testing to ensure effective solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container relative flex flex-col justify-between h-full max-w-6xl px-10 mx-auto xl:px-0">
          <div className="w-full">
            <div className="flex flex-col w-full mt-6 mb-10 sm:flex-row">
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        Core Technical Skills
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      REST API integration, SQL querying &amp; analysis, and
                      advanced JSON/XML data handling.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        Development Concepts
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      Backend workflow automation, data mapping, and webhook
                      implementation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <div className="relative h-full ml-0 mb-6 sm:mr-6">
                  <span className="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-secondary rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px]"></span>
                  <div className="relative h-full p-5 bg-primary border-2 rounded-tl-[30px] rounded-tr-[50px] rounded-br-[30px] rounded-bl-[50px] border-secondary">
                    <div className="flex items-center -mt-1">
                      <h3 className="my-2 ml-3 text-lg font-bold text-primary-content">
                        QA &amp; Troubleshooting
                      </h3>
                    </div>
                    <p className="mb-2 text-primary-content">
                      User Acceptance Testing (UAT), technical troubleshooting,
                      and log analysis.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
